<template>
  <div id="contact">
    <PageHeader />
    <main>
      <div class="container mt-6">
        <h4 class="center-align">Hubungi Rasylva</h4>
        <div class="row mt-6">
          <div class="col s12 l6 offset-l3">
            <TextInputRow
              v-model="input.email"
              label="Email"
              name="email"
              ref="email"
              align="left"
              autocomplete="on"
              :clearable="false"
              :error-message="validation.email"
              @input="clearValidation"
              @enter="$refs.title.focus()"
            />
            <TextInputRow
              v-model="input.title"
              label="Judul"
              name="title"
              ref="title"
              align="left"
              :clearable="false"
              :error-message="validation.title"
              @input="clearValidation"
              @enter="$refs.message.focus()"
            />
            <TextareaRow
              v-model="input.message"
              label="Pesan"
              name="message"
              ref="message"
              align="left"
              :clearable="false"
              :error-message="validation.message"
              @input="clearValidation"
              @enter="sendMessage"
            />
            <div class="row mrgn-top--3">
              <div class="col s12">
                <button class="btn waves-effect waves-light width-1" @click.prevent="sendMessage" :disabled="!isValid">
                  <span>Kirim</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <PageFooter />

    <ToastNotif
      :value="toast.isActive"
      :text="toast.text"
      :type="toast.type"
      :action-label="toast.actionLabel"
      @input="resetToast"
      @action-click="toast.onActionClick"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import TextInputRow from '~/components/form/text-input-row';
import TextareaRow from '~/components/form/textarea-row';
import PageFooter from '~/components/page-footer';
import PageHeader from '~/components/page-header';
import ToastNotif from '~/components/toast-notif';
import { mustBeEmail, mustBeFilled } from '~/helpers/validator';

export default {
  components: {
    PageFooter,
    PageHeader,
    TextareaRow,
    TextInputRow,
    ToastNotif,
  },
  data: () => ({
    input: {
      email: '',
      title: '',
      message: '',
    },
    validation: {
      email: '',
      title: '',
      message: '',
    },
  }),
  computed: {
    ...mapGetters({
      toast: 'toast/get',
    }),
    isValid() {
      return Object.values(this.validation).every((v) => !v);
    },
  },
  async mounted() {
    await this.$nextTick();
    setTimeout(async () => {
      await this.$rasylvaApi.init(true);
    }, 10);
  },
  methods: {
    ...mapActions({
      setToast: 'toast/set',
      resetToast: 'toast/reset',
    }),
    clearValidation() {
      this.validation = {
        email: '',
        title: '',
        message: '',
      };
      this.resetToast();
    },
    validate() {
      this.validation.email = mustBeFilled(this.input.email, 'Email') || mustBeEmail(this.input.email);
      this.validation.title = mustBeFilled(this.input.title, 'Judul');
      this.validation.message = mustBeFilled(this.input.message, 'Pesan');
    },
    async sendMessage() {
      this.validate();
      if (!this.isValid) return;
      try {
        const response = await this.$rasylvaApi.post('/contacts', { body: { ...this.input } });
        if (response?.status !== 'ok') throw response;
        this.setToast({ text: response.data });
      } catch (error) {
        this.setToast({ type: 'error', text: error.error || error });
      }
    },
  },
};
</script>
